<div class="card mt-3">
  <div class="card-body p-0 rounded-lg d-flex align-items-center">
    <a [routerLink]="'salon/' + item.slug">
      <div class="salon-logo" [style.backgroundImage]="'url(' + item.logo + ')'"></div>
    </a>
    <!-- <a class="w-100" [routerLink]="'salons/' + item.slug"> -->
    <a class="w-100" routerLink="/salon">
      <div class="salon-description-container w-auto mx-3">
          <p class="salon-name mb-0">John Doe's Hair Salon</p>
          <p class="salon-description mb-0"><small>Hair-cuts, colouring and styling.</small></p>
          <div class="salon-meta mb-0 d-flex justify-content-between">
            <small class="salon-starting-price">Starting at <span style="font-weight: 600;">£<span class="salon-starting-price--price">10</span></span></small>
            <small class="salon-rating mb-0"><i class="fas fa-star"></i> 4.9</small>
        </div>
      </div>
    </a>
  </div>
</div>